import React from "react";
import Text from "@amzn/meridian/text";

const BreaksTab: React.FC = () => (
  <Text>Breaks settings coming soon.</Text>
);

export default BreaksTab;
